import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import emailjs from "emailjs-com";
import "./ContactPage.css";
import Footer from "../../components/Footer/Footer";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.consent) {
      alert("Please give consent before submitting.");
      return;
    }

    // Prepare data for EmailJS template
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
      reply_to: formData.email,
      consent: formData.consent
        ? "Yes, I agree to be contacted"
        : "No, I do NOT give consent",
    };

    emailjs
      .send(
        "service_r8gkv4a", // ✅ Your Service ID
        "template_7qm5tgh", // ✅ Your Template ID
        templateParams,
        "aRMQS4q-4RNgPUyhq", // ✅ Your Public Key
      )
      .then(
        () => {
          alert("Message sent successfully!");

          // Reset form after success
          setFormData({
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
            consent: false,
          });
        },
        (error) => {
          alert("Failed to send message.");
          console.error("EmailJS Error:", error);
        },
      );
  };

  return (
    <>
      <div className="container py-5">
        <h2 className="mb-4">Get In Touch</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Phone</label>
            <input
              type="text"
              className="form-control"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Subject</label>
            <input
              type="text"
              className="form-control"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label>Your message (optional)</label>
            <textarea
              className="form-control"
              rows="5"
              name="message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              name="consent"
              checked={formData.consent}
              onChange={handleChange}
            />
            <label className="form-check-label">
              By providing my phone number to “Livosol LLC”, I agree and
              acknowledge that Livosol LLC may send text messages to my wireless
              phone number for any purpose. Message frequency will vary, and
              Message and data rates may apply. If you need further assistance,
              please reply “HELP”. You can also opt out by replying “STOP.”
            </label>
            <button type="submit" className="btn btn-dark form-btn">
              SUBMIT
            </button>
            <h5 className="text-center mt-4">
              No mobile information will be shared with third parties/affiliates
              for marketing/promotional purposes. All the above categories
              exclude text messaging originator opt-in data and consent; this
              information will not be shared with any third parties.
            </h5>
          </div>
        </form>
      </div>

      <Footer />
    </>
  );
};

export default ContactPage;
